import { MdEmail, MdPhone, MdLocationOn, MdChevronRight } from "react-icons/md";

import Line from "../../../assests/solutionImages/petTagTheme/line.svg";

import Link from "../../../assests/solutionImages/petTagTheme/link.svg";
import Facebook from "../../../assests/solutionImages/petTagTheme/fb.svg";
import Instagram from "../../../assests/solutionImages/petTagTheme/instagram.svg";

function PetTagUrlTheme({ card }) {
  console.log(card);

  const getFormattedAddress = () => {
    const address = card?.data?.ownerInfo?.address;
    if (!address) return "";

    const parts = [];
    if (address.line1) parts.push(address.line1);
    if (address.line2) parts.push(address.line2);

    const cityStateParts = [];
    if (address.city) cityStateParts.push(address.city);
    if (address.state) cityStateParts.push(address.state);

    if (cityStateParts.length > 0) {
      parts.push(cityStateParts.join(", "));
    }

    if (address.country) parts.push(address.country);
    if (address.zipCode) parts.push(address.zipCode);

    return parts.join(" - ");
  };

  return (
    <div className="bg-[#55544d] md:py-4 p-2 w-full">
      <div className="min-h-screen pb-2 overflow-hidden  relative max-w-[393px] mx-auto rounded-lg bg-[#fefdd6] text-white font-poppins">
        {/* Header Image */}
        <div className="w-full h-64  overflow-hidden">
          <img
            src={card?.profileImage}
            alt="Pet Profile"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Name Card - Changed from absolute to relative positioning */}
        <div className="bg-[#232323] relative left-1/2 transform -translate-x-1/2 font-poppins rounded-xl gap-[6px] -mt-10 mb-6 p-4 text-center shadow-lg w-[80%]">
          <h1 className="text-xl font-semibold text-custom-gradient break-words">
            {card?.data?.basicInfo?.name || "Pet Name"}
          </h1>
          <img className="mt-2" src={Line} alt="Line" />
          <p className="text-sm text-[#999999] mt-2 break-words">
            {card?.data?.basicInfo?.behaviour || "Friendly"} |{" "}
            {card?.data?.basicInfo?.age || "Age"} |{" "}
            {card?.data?.basicInfo?.gender || "Gender"}
          </p>
        </div>

        {/* Contact Icons - Removed mt-20, added mt-4 for consistent spacing */}
        <div className="flex justify-center gap-2 mt-4">
          <svg width="0" height="0">
            <defs>
              <linearGradient
                id="gold-gradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop stopColor="#B07908" offset="0%" />
                <stop stopColor="#FAE255" offset="50%" />
                <stop stopColor="#A66F00" offset="100%" />
              </linearGradient>
            </defs>
          </svg>

          <div
            className="h-12 w-12 bg-[#232323] rounded-full flex items-center justify-center cursor-pointer hover:bg-[#2f2f2f]"
            onClick={() =>
              window.open(`mailto:${card.data.ownerInfo.email}`, "_blank")
            }
          >
            <MdEmail fill="url(#gold-gradient)" size={20} />
          </div>

          <div
            className="h-12 w-12 bg-[#232323] rounded-full flex items-center justify-center cursor-pointer hover:bg-[#2f2f2f]"
            onClick={() =>
              window.open(
                `tel:${card.data.ownerInfo.emergencyContacts[0]}`,
                "_blank"
              )
            }
          >
            <MdPhone fill="url(#gold-gradient)" size={20} />
          </div>

          <div className="h-12 w-12 bg-[#232323] rounded-full flex items-center justify-center cursor-pointer hover:bg-[#2f2f2f]">
            <MdLocationOn fill="url(#gold-gradient)" size={20} />
          </div>
        </div>

        {/* About Me */}
        {card?.data?.aboutSection?.enabled && (
          <div className="bg-[#232323] text-white mt-6 mx-4 p-4 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              {card.data.aboutSection.title}
            </h2>
            <p className="text-sm text-gray-300 break-words">
              {card.data.aboutSection.description}
            </p>
          </div>
        )}

        {/* Medical Info */}
        {card?.data?.medicalInfo?.isVisible && (
          <div className="bg-[#232323] text-white mt-4 mx-4 mb-4 p-4 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              {card.data.medicalInfo.title}
            </h2>
            <div className="text-sm divide-y divide-[#444444]">
              {card?.data?.medicalInfo?.details?.map((detail, index) => (
                <div
                  key={detail.id || index}
                  className="flex justify-between py-4"
                >
                  <span className="text-[#999999] break-words max-w-[45%]">{detail.label}</span>
                  <span className="font-normal break-words max-w-[45%] text-right">{detail.value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Owner Info */}
        {card?.data?.ownerInfo && (
          <div className="bg-[#232323] mx-4 mb-4 p-4 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              {card.data.ownerInfo.title}
            </h2>
            <div className="text-sm divide-y divide-[#444444]">
              {card?.data?.ownerInfo?.emergencyContacts?.map(
                (contact, index) => (
                  <div key={contact.id || index} className="py-4">
                    <p className="text-[#999999] font-light break-words max-w-[45%]">{contact.label}</p>
                    <a
                      href={`tel:${contact.value}`}
                      className="text-white font-medium hover:underline break-words max-w-[45%] text-right"
                    >
                      {contact.value}
                    </a>
                  </div>
                )
              )}

              {card?.data?.ownerInfo?.email && (
                <div className="py-4">
                  <p className="text-[#999999] text-sm break-words">E-mail</p>
                  <a
                    href={`mailto:${card.data.ownerInfo.email}`}
                    className="text-white font-medium hover:underline break-words"
                  >
                    {card.data.ownerInfo.email}
                  </a>
                </div>
              )}

              {card?.data?.ownerInfo?.address && (
                <div className="py-4">
                  <p className="text-[#999999] text-sm break-words">
                    {card.data.ownerInfo.address.label}
                  </p>
                  <p className="text-white font-medium break-words">
                    {getFormattedAddress()}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Other Info */}
        {card?.data?.otherInfo?.isVisible && (
          <div className="bg-[#232323] text-white mt-4 mx-4 mb-4 p-4 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              {card.data.otherInfo.title}
            </h2>
            <div className="text-xs divide-y divide-[#444444]">
              {card?.data?.otherInfo?.details?.map((detail, index) => (
                <div
                  key={detail.id || index}
                  className="flex justify-between py-4"
                >
                  <span className="text-[#999999] break-words max-w-[45%]">{detail.label}</span>
                  <span className="font-normal break-words max-w-[45%] text-right">{detail.value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Image Gallery */}
        {card?.data?.gallery?.enabled && (
          <div className="bg-[#232323] text-white mt-4 mx-4 mb-4 p-4 md:pb-8 rounded-xl">
            {card?.data?.gallery?.headingEnabled && (
              <h2 className="text-xl font-semibold text-custom-gradient mb-2">
                {card.data.gallery.title}
              </h2>
            )}
            <span className="text-xs text-[#999999]">
              {card.data.gallery.description}
            </span>
            <div className="space-y-2 mt-2">
              {card?.data?.gallery?.uploadedImages?.map((image, index) => (
                <div key={index} className="h-56 rounded-xl overflow-hidden">
                  <img
                    src={image}
                    className="h-full w-full object-cover"
                    alt={`pet  ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Behaviour */}
        {card?.data?.basicInfo?.behaviour && (
          <div className="bg-[#232323] text-white mt-4 mx-4 mb-4 p-4 md:pb-8 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              Behaviour
            </h2>
            <p className="text-xs text-[#EEEEEE] break-words">
              {card.data.basicInfo.behaviour}
            </p>
          </div>
        )}

        {/* Web Links */}
        {card?.data?.webLinks?.enabled && (
          <div className="bg-[#232323] text-white mt-4 mx-4 mb-4 p-4 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              {card.data.webLinks.title}
            </h2>
            <p className="text-xs text-[#999999] mb-2 break-words">
              {card.data.webLinks.description}
            </p>
            {card?.data?.webLinks?.links?.map((link, index) => (
              <a
                key={link.id || index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between py-3 hover:bg-[#2f2f2f] rounded-md transition-colors"
              >
                <div className="flex items-center gap-4">
                  <div className="h-10 w-10 flex items-center justify-center">
                    <img src={Link} className="w-full h-full" alt="link" />
                  </div>
                  <div className="max-w-[200px] break-words">
                    <p className="font-bold text-custom-gradient break-words">
                      {link.title}
                    </p>
                    <p className="text-sm text-gray-400 break-words">{link.subtitle}</p>
                  </div>
                </div>
                <MdChevronRight size={24} className="text-gray-500" />
              </a>
            ))}
          </div>
        )}

        {/* Social Links */}
        {card?.data?.socialMedia?.enabled && (
          <div className="bg-[#232323] text-white mt-4 mx-4 mb-4 p-4 rounded-xl">
            <h2 className="text-xl font-semibold text-custom-gradient mb-2 break-words">
              {card.data.socialMedia.title}
            </h2>
            <p className="text-xs text-[#999999] mb-2 break-words">
              {card.data.socialMedia.description}
            </p>
            {card?.data?.socialMedia?.links?.map((link, index) => (
              <a
                key={link.id || index}
                href={link.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between py-3 hover:bg-[#2f2f2f] rounded-md transition-colors"
              >
                <div className="flex items-center gap-4">
                  <div className="h-10 w-10 flex items-center justify-center">
                    <img
                      src={link.platform === "facebook" ? Facebook : Instagram}
                      className="w-full h-full"
                      alt={link.platform}
                    />
                  </div>
                  <div className="max-w-[200px] break-words">
                    <p className="font-bold text-custom-gradient break-words">
                      {link.title}
                    </p>
                    <p className="text-sm text-gray-400 break-words">{link.subtitle}</p>
                  </div>
                </div>
                <MdChevronRight size={24} className="text-gray-500" />
              </a>
            ))}
          </div>
        )}

        {/* Floating Button */}
        {card?.data?.ownerInfo?.isFloatingButtonEnabled && (
          <div className="fixed bottom-8 right-8">
            <button
              className="bg-white text-black rounded-full p-4 shadow-lg hover:bg-gray-100 transition-colors"
              onClick={() => {
                if (card?.data?.ownerInfo?.emergencyContacts?.length > 0) {
                  window.location.href = `tel:${card.data.ownerInfo.emergencyContacts[0].value}`;
                }
              }}
            >
              {card?.data?.ownerInfo?.floatingButtonText}
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default PetTagUrlTheme;
